import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';

import { startLoading, endLoading } from 'ducks/loader';
import { closeCaption } from 'ducks/display';
import { getScreenshots, downloadEaScreenshotPDF } from 'ducks/backupBank';

import {
  getAvailabilityCredentials,
  setClearAvailabilityCredentials,
} from 'ducks/availabilityCredentials';
import { globalLoaderSelector } from 'ducks/loader';
import { isLogged, retrieveTeamMember } from 'ducks/user';

import Appointments from './Appointments';
import styles from './Appointments.style';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from 'common/contexts/UserContext';
import { useRegion } from 'common/hooks/region';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { ERL_STOP_THE_CLOCK_PARAMS } from './params';
import { ErlContext, useErlData } from './context';

const mapStateToProps = (state) => {
  const { availabilityCredentials } = state;
  return {
    availabilityCredentials,
    isLoading: globalLoaderSelector(state),
    isLogged: isLogged(state),
    refreshToken: state.refreshToken,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeLegend: () => dispatch(closeCaption()),

  getScreenshotsBySL: (slKey, region, cb) => {
    dispatch(getScreenshots(slKey, region, cb));
  },

  getEaScreenshotPDF: (requestBody, fileNameData, region, cb) => {
    dispatch(downloadEaScreenshotPDF(requestBody, fileNameData, region, cb));
  },

  startLoadingOnDownload: () => {
    dispatch(startLoading('downloadEA'));
  },

  endLoadingOnDownload: () => {
    dispatch(endLoading('downloadEA'));
  },

  clearAvailabilityCredentials: () => {
    dispatch(setClearAvailabilityCredentials());
  },
  getAppointmentsAvailabilityCredentials: (portCollectionCode) => {
    dispatch(getAvailabilityCredentials(portCollectionCode));
  },

  getRecipients: () => dispatch(retrieveTeamMember()),
});

const withHooksHOC = (Component) => {
  return (props) => {
    const navigate = useNavigate();
    const { user } = useUserContext();
    const region = useRegion();
    const { searchParams } = useCustomSearchParams(ERL_STOP_THE_CLOCK_PARAMS);

    const value = useErlData();

    return (
      <ErlContext.Provider value={value}>
        <Component
          user={user}
          navigate={navigate}
          region={region}
          {...props}
          key={region.code}
          showCurrentShiftOnly={searchParams.showCurrentShiftOnly}
          forDatetime={searchParams.forDatetime}
          shippingLine={searchParams.shippingLine}
          containerType={searchParams.containerType}
          context={value}
        />
      </ErlContext.Provider>
    );
  };
};

export default compose(
  withStyles(styles),
  withHooksHOC,
  connect(mapStateToProps, mapDispatchToProps)
)(Appointments);
